import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Header,
  Showcase,
  SectionTitle,
  Intro,
} from '../../../../components'
import data from './data.json'
import './style.scss'

export default props => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
        exclusive={true}
      />
      <Layout
        category="Overview"
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            The list actions pattern presents the user with a list of items that
            each have one or more associated actions. All actions are applied to
            the item itself, not the list overall. The header signals the start
            of the list and provides the title. Each item is required to have a
            title and an action element. The optional icon and subtitle can add
            further clarity if needed.
          </p>
        </Intro>
        <SectionTitle>Variants</SectionTitle>
        <p>
          The design of the list item depends on the type and number of
          associated actions.
        </p>
        <Showcase
          site={data.site}
          title="Standard"
          text="Used when the item action navigates the user to a new page to provide more details. The click target fills the entire item container."
        >
          <div class="p-list-action l-margin-bottom--xxlarge">
            <h4 class="p-list-action__title">Standard List Actions</h4>
            <button class="p-list-action__item">
              <i
                class="p-list-action__item-icon icon icon--card"
                role="img"
              ></i>
              <span class="p-list-action__item-content">
                <span class="p-list-action__item-title--cta">
                  Personal Checking
                </span>
                <span class="p-list-action__item-subtitle">
                  Account ending in: 5551
                </span>
              </span>
              <span class="p-list-action__item-actions">
                <i
                  class="icon icon--arrow-without-tail-right p-list-action__icon--animated p-list-action__icon--slide"
                  role="img"
                ></i>
              </span>
            </button>
            <button class="p-list-action__item">
              <i
                class="p-list-action__item-icon icon icon--card"
                role="img"
              ></i>
              <span class="p-list-action__item-content">
                <span class="p-list-action__item-title--cta">
                  Joint Checking
                </span>
                <span class="p-list-action__item-subtitle">
                  Account ending in: 5552
                </span>
              </span>
              <span class="p-list-action__item-actions">
                <i
                  class="icon icon--arrow-without-tail-right p-list-action__icon--animated p-list-action__icon--slide"
                  role="img"
                ></i>
              </span>
            </button>
            <button class="p-list-action__item">
              <i
                class="p-list-action__item-icon icon icon--card"
                role="img"
              ></i>
              <span class="p-list-action__item-content">
                <span class="p-list-action__item-title--cta">
                  Credit Acccount
                </span>
                <span class="p-list-action__item-subtitle">
                  Account ending in: 5553
                </span>
              </span>
              <span class="p-list-action__item-actions">
                <i
                  class="icon icon--arrow-without-tail-right p-list-action__icon--animated p-list-action__icon--slide"
                  role="img"
                ></i>
              </span>
            </button>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Single Action"
          text="Used when there is a single action associated with each list item, such as Edit or Delete. Because the click target is now limited to the button, the item title is no longer green."
        >
          <div class="p-list-action l-margin-bottom--xxlarge">
            <h4 class="p-list-action__title">Single Action List Items</h4>
            <div class="p-list-action__item">
              <i
                class="p-list-action__item-icon icon icon--card"
                role="img"
              ></i>
              <span class="p-list-action__item-content">
                <span class="p-list-action__item-title">Personal Checking</span>
                <span class="p-list-action__item-subtitle">
                  Account ending in: 5551
                </span>
              </span>
              <span class="p-list-action__item-actions">
                <button class="c-button">Deactivate Card</button>
              </span>
            </div>
            <div class="p-list-action__item">
              <i
                class="p-list-action__item-icon icon icon--card"
                role="img"
              ></i>
              <span class="p-list-action__item-content">
                <span class="p-list-action__item-title">Joint Checking</span>
                <span class="p-list-action__item-subtitle">
                  Account ending in: 5552
                </span>
              </span>
              <span class="p-list-action__item-actions">
                <button class="c-button--primary">Activate Card</button>
              </span>
            </div>
            <div class="p-list-action__item">
              <i
                class="p-list-action__item-icon icon icon--card"
                role="img"
              ></i>
              <span class="p-list-action__item-content">
                <span class="p-list-action__item-title">Credit Account</span>
                <span class="p-list-action__item-subtitle">
                  Account ending in: 5553
                </span>
              </span>
              <span class="p-list-action__item-actions">
                <button class="c-button">Deactivate Card</button>
              </span>
            </div>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Multiple Action"
          text="Used when there are two or three actions associated with each list item. To save space, actions are communicated with icons instead of buttons, however icons must be labeled. Because the click target is now limited to the icon actions, the item title is no longer green."
        >
          <div class="p-list-action l-margin-bottom--xxlarge">
            <h4 class="p-list-action__title">Multiple Action List Items</h4>
            <div class="p-list-action__item">
              <i
                class="p-list-action__item-icon icon icon--card"
                role="img"
              ></i>
              <span class="p-list-action__item-content">
                <span class="p-list-action__item-title">Personal Checking</span>
                <span class="p-list-action__item-subtitle">
                  Account ending in: 5551
                </span>
              </span>
              <span class="p-list-action__item-actions">
                <button
                  class="p-list-action__icon-action p-list-action__icon--animated p-list-action__icon--pop icon icon--cog"
                  alt="Settings"
                >
                  <span class="p-list-action__icon-action-label">Settings</span>
                </button>
                <button
                  class="p-list-action__icon-action p-list-action__icon--animated p-list-action__icon--pop icon icon--pencil"
                  alt="Edit"
                >
                  <span class="p-list-action__icon-action-label">Edit</span>
                </button>
                <button
                  class="p-list-action__icon-action p-list-action__icon--animated p-list-action__icon--pop icon icon--trash-can"
                  alt="Delete"
                >
                  <span class="p-list-action__icon-action-label">Delete</span>
                </button>
              </span>
            </div>
            <div class="p-list-action__item">
              <i
                class="p-list-action__item-icon icon icon--card"
                role="img"
              ></i>
              <span class="p-list-action__item-content">
                <span class="p-list-action__item-title">Joint Checking</span>
                <span class="p-list-action__item-subtitle">
                  Account ending in: 5552
                </span>
              </span>
              <span class="p-list-action__item-actions">
                <button
                  class="p-list-action__icon-action icon icon--cog p-list-action__icon--animated  p-list-action__icon--pop"
                  alt="Settings"
                >
                  <span class="p-list-action__icon-action-label">Settings</span>
                </button>
                <button
                  class="p-list-action__icon-action icon icon--pencil p-list-action__icon--animated  p-list-action__icon--pop"
                  alt="Edit"
                >
                  <span class="p-list-action__icon-action-label">Edit</span>
                </button>
                <button
                  class="p-list-action__icon-action icon icon--trash-can p-list-action__icon--animated  p-list-action__icon--pop"
                  alt="Delete"
                >
                  <span class="p-list-action__icon-action-label">Delete</span>
                </button>
              </span>
            </div>
            <div class="p-list-action__item">
              <i
                class="p-list-action__item-icon icon icon--card"
                role="img"
              ></i>
              <span class="p-list-action__item-content">
                <span class="p-list-action__item-title">Credit Acccount</span>
                <span class="p-list-action__item-subtitle">
                  Account ending in: 5553
                </span>
              </span>
              <span class="p-list-action__item-actions">
                <button
                  class="p-list-action__icon-action icon icon--cog p-list-action__icon--animated  p-list-action__icon--pop"
                  alt="Settings"
                >
                  <span class="p-list-action__icon-action-label">Settings</span>
                </button>
                <button
                  class="p-list-action__icon-action icon icon--pencil p-list-action__icon--animated  p-list-action__icon--pop"
                  alt="Edit"
                >
                  <span class="p-list-action__icon-action-label">Edit</span>
                </button>
                <button
                  class="p-list-action__icon-action icon icon--trash-can p-list-action__icon--animated  p-list-action__icon--pop"
                  alt="Delete"
                >
                  <span class="p-list-action__icon-action-label">Delete</span>
                </button>
              </span>
            </div>
          </div>
        </Showcase>
        <hr />
        <SectionTitle>States</SectionTitle>
        <p>
          On hover, the arrow on standard list action items is animated to push
          to the right, indicating that the button will move the user forward.
          The buttons in the single action variant have the same hover behavior
          as the{' '}
          <Link class="link" to={'/' + data.site + '/components/button/design'}>
            button
          </Link>{' '}
          component. The icons on multiple action list items can animate to draw
          attention to the desired actions.
        </p>
        <hr />
        <SectionTitle>Design Environment</SectionTitle>
        <p>
          Use this pattern to present items that typically appear in multiples,
          even if there only happens to be one in a given list. Make sure to
          include enough space when placing this pattern next to other click
          targets and icons.
        </p>
        <hr />
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          The list title, item title and item subtitle should all be kept to a
          single line of text. Use sentence case for the list and item titles as
          well as the subtitle. Do no include end punctuation. Follow the
          guidelines for the general{' '}
          <Link class="link" to={'/' + data.site + '/components/button/design'}>
            button
          </Link>{' '}
          component.
        </p>
      </Layout>
    </>
  )
}
